import { Required, DataValidator, IsArray, IsString } from "@/utils/type-vaildator";
import api from "./api";

export interface GenerateKlingImageToVodRequest {
  agentId: string;
  fileUrl?: string;
  fileUrl1?: string;
  text: string;
  level?: string;
  model: string;
  duration?: number;
  aspectRatio?: string;
  type: number;
}

class MakeGenerateResponseRaw {
  @Required("taskIds cannot be empty")
  @IsString("taskIds must be a string")
  taskIds: string;
}

// 生成可灵视频(图生视频)
export const generateKlingImageToVod = async ({
  agentId,
  text,
  type,
  model,
  duration,
  aspectRatio,
  level,
  fileUrl,
  fileUrl1,
}: GenerateKlingImageToVodRequest): Promise<string> => {
  const res = await api.post<MakeGenerateResponseRaw>("/sj/kling/img2vod/create", {
    agent_id: agentId,
    prompt: text,
    level,
    model,
    duration,
    aspectRatio,
    fileUrl,
    fileUrl1,
    type,
  });
  const root = res.data;
  const validated = DataValidator.validateOrThrow(root, MakeGenerateResponseRaw);
  return validated.taskIds;
};
